import React from 'react';

function platformBadgeClasses(platform) {
  switch (platform) {
    case 'ANDROID':
      return 'bg-emerald-500 text-white';
    case 'IOS':
      return 'bg-white text-black';
    default:
      return 'bg-dark-surface text-dark-text-secondary';
  }
}

export const PLATFORM_ICONS = {
  IOS: '/assets/app_store.png',
  ANDROID: '/assets/google_play_store.webp',
};

/** Maps API values (e.g. ios, android) to IOS | ANDROID for badge display. */
export function normalizePlatform(value) {
  if (value == null || String(value).trim() === '') return null;
  const u = String(value).trim().toUpperCase();
  if (u === 'IOS' || u === 'ANDROID') return u;
  return null;
}

/** Legend row for pie charts: ios/android labels with store icons when recognized. */
export function PlatformLegendLabel({ label }) {
  const platform = normalizePlatform(label);
  const iconSrc = platform ? PLATFORM_ICONS[platform] : null;
  return (
    <span className="inline-flex items-center gap-1.5 text-dark-text-secondary text-xs">
      {iconSrc ? (
        <img src={iconSrc} alt="" className="w-4 h-4 object-contain shrink-0" aria-hidden />
      ) : null}
      <span>{label}</span>
    </span>
  );
}

export default function PlatformBadge({ platform }) {
  const iconSrc = PLATFORM_ICONS[platform];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${platformBadgeClasses(platform)}`}
    >
      {iconSrc && (
        <img src={iconSrc} alt={`${platform} icon`} className="w-3.5 h-3.5 object-contain" />
      )}
      {platform}
    </span>
  );
}
